import React from "react";
import { IonItem, IonLabel, IonAccordion } from "@ionic/react";

export interface Props {}

const VenueHostTips: React.FC<Props> = () => {
  return (
    <IonAccordion value="VenueHostTips">
      <IonItem slot="header" color="light">
        <IonLabel>Venue and Host Tips</IonLabel>
      </IonItem>
      <div className="ion-padding" slot="content">
        <ul>
          <li>
            We recommend that, during the day of your quiz, your account is
            accessed and tested on-screen. Regular pub quizzes will be available
            to access by 2pm.
          </li>
          <li>
            If a host wants to review the questions of the quiz, use the
            &apos;Review Questions&apos; option to read through or preview the
            content
          </li>
          <li>
            Do not leave the Qwizard app open or on-screen for extended periods
            without interacting with it. It is good practice to log out and log
            back in before commencing your quiz to ensure that you have the
            latest content.
          </li>
          <li>
            Venues and hosts should be clear on the quiz format and duration
            (set a target finish time and clearly communicate drinks breaks, if
            any)
          </li>
          <li>
            Hosts should try to meet the teams personally, communicate directly
            with the players and invite all patrons to participate
          </li>
          <li>
            Hosts should help to promote any quiz-night specials or Qwizard
            adverts
          </li>
          <li>
            Focus on the results &ndash; refer to Qwizard&rsquo;s graphical
            results and use the live progress scores and positive feedback to
            create a nice competitive quiz
          </li>
        </ul>
      </div>
    </IonAccordion>
  );
};

export default VenueHostTips;
